/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Checkbox, Col, Form, Row, Typography } from 'antd';

// Misc imports
import userHasEditAccess from '../../../../utils/misc/hasEditAccess';
import useTheme from '../../../../utils/hooks/useTheme';

const BotDeploymentsFacebookLayoutForm = ({
  form,
  formData = {},
  isCreateMode = false,
  userRoles = {}
}) => {

  const { t } = useTranslation();
  const { formProps } = useTheme();
  const hasEditAccess = isCreateMode ? true : userHasEditAccess(formData?.tenant?.organizationId, userRoles?.organizationRoles, formData?.tenant.id, userRoles?.tenantRoles, true);

  return (
    <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
      <Col xs={formProps.mainColSpan}>
        <Typography.Text>
          {t('Actions')}
        </Typography.Text>
        <Typography.Paragraph className="fs-sm" type="secondary">
          {t(`Control your agent's behavior with custom action settings.`)}
        </Typography.Paragraph>
      </Col>

      <Col xs={formProps.secondaryColSpan}>
        <Row className="align-items-baseline">
          <Col flex="auto" xs={1}>
            <Form.Item
              labelCol={{ span: 12 }}
              name={'hideTypingIndicator'}
              valuePropName="checked"
              className="mb-2"
            >
              <Checkbox disabled={!hasEditAccess}/>
            </Form.Item>
          </Col>

          <Col>
            <Typography.Text>
              {t('Hide Typing Indicator')}
            </Typography.Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

BotDeploymentsFacebookLayoutForm.propTypes = {
  formData: PropTypes.object,
  isCreateMode: PropTypes.bool,
  userRoles: PropTypes.object,
  form: PropTypes.object
};

export default BotDeploymentsFacebookLayoutForm;
